/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { css } from "@emotion/css";
import { space, themeTokens, lineHeight, borderWidth } from "@octopusdeploy/design-system-tokens";
import cn from "classnames";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import remarkGfm from "remark-gfm";
import ExternalLink from "../Navigation/ExternalLink/ExternalLink";
import InternalLink from "../Navigation/InternalLink";
import { AppRelativeLinkPattern, isExternalUrl, isInternalUrl } from "../TextWithLinks/parseLinks";
interface MarkdownProps {
    markup: string;
    mutedTextColor?: boolean;
    noMargins?: boolean;
}
function Markdown({ markup, mutedTextColor, noMargins }: MarkdownProps) {
    return (<div className={cn(styles.base, {
            [styles.mutedTextColorStyling]: mutedTextColor,
            [styles.noMarginsStyling]: noMargins,
        })}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, rehypeSanitize]} components={{
            a: ({ href, children, node, ...props }) => {
                if (href && isInternalUrl(href)) {
                    const internalUrl = href.replace(AppRelativeLinkPattern, "");
                    return <InternalLink to={internalUrl}>{children}</InternalLink>;
                }
                else if (href && isExternalUrl(href)) {
                    return <ExternalLink href={href}>{children}</ExternalLink>;
                }
                return (<a href={href} rel="noopener noreferrer" target="_blank" {...props}>
                                {children}
                            </a>);
            },
        }}>
                {markup}
            </ReactMarkdown>
        </div>);
}
export default Markdown;
const listPaddingLeft = space[40];
const styles = {
    base: css({
        lineHeight: lineHeight.xSmall,
        "& .list": {
            paddingLeft: listPaddingLeft,
        },
        ul: {
            listStyleType: "disc",
            paddingLeft: listPaddingLeft,
        },
        ol: {
            listStyleType: "decimal",
            paddingLeft: listPaddingLeft,
        },
        blockquote: {
            borderLeft: [borderWidth["4"], "solid", themeTokens.color.border.primary].join(" "),
            paddingLeft: space[16],
        },
    }),
    mutedTextColorStyling: css({
        p: {
            color: themeTokens.color.text.secondary,
        },
    }),
    noMarginsStyling: css({
        p: {
            margin: 0,
        },
    }),
};
